import React from "react";

interface SelfcarePageContentProps {
    children: React.ReactNode
    className?: string
    title?: React.ReactNode
}

export default function SelfcarePageContent({title, children, className}: SelfcarePageContentProps) {
    return <div className={`selfcare-page-content ${className ?? ''}`}>
        {title && <h1 className="heading heading--big">{title}</h1>}
        {children}
    </div>
}
